<template>
    <u-btn-arrow-text-fit v-bind="$attrs" @click="$emit('click')">
        <icon-arrow-tertiary v-bind="{ direction }" />
    </u-btn-arrow-text-fit>
</template>

<script>
import IconArrowTertiary from "@/components/publish/parents/icons/icon-arrow-tertiary.vue";
import UBtnArrowTextFit from "@/components/publish/styles/buttons/u-btn-arrow-text-fit.vue";

export default {
    props: {
        direction: { type: String, default: "left" },
    },
    components: {
        IconArrowTertiary,
        UBtnArrowTextFit,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
